import { useEffect } from 'react';

import { AuthService, UserRoles } from 'shared/lib/keycloak';
import { getAmpConfig } from 'shared/config/amp-config';

export const useStudentRedirect = () => {
  useEffect(() => {
    if (AuthService.getRole() === UserRoles.STUDENT) {
      window.location.replace(getAmpConfig().studentHome);
    }
  }, []);
};
